import React from 'react';
import { Link } from 'react-router-dom';

// ─────────────────────────────────────────────────────────────
// EVENT LIST — to add, change, or remove an event, edit this list.
// `date` must be YYYY-MM-DD. Events automatically disappear from
// the page the day after they happen, so old events never linger.
// ─────────────────────────────────────────────────────────────
const events = [
  {
    date: '2026-10-24',
    title: 'POST Houston Diwali',
    performers: ['Level 1', 'Level 2'],
    emoji: '🪔',
  },
  {
    date: '2026-11-14',
    title: 'MD Anderson Boot Walk',
    performers: ['Level 1', 'Level 2', 'Level 3', 'Elite'],
    emoji: '🎗️',
  },
  {
    date: '2026-11-14',
    title: 'Masala Radio Diwali at Levy Park',
    performers: ['Level 3', 'Elite', 'NatyaFusion'],
    emoji: '✨',
  },
  {
    date: '2026-12-16',
    title: 'Chilanka Annual Christmas Program',
    performers: ['School-wide event'],
    emoji: '🎄',
  },
  {
    date: '2027-02-28',
    title: 'Houston Rockets Pregame Show',
    performers: ['Level 2', 'Level 3', 'Elite', 'NatyaFusion'],
    emoji: '🏀',
    highlight: true,
  },
];

const formatDate = (iso) => {
  const [y, m, d] = iso.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return {
    weekday: date.toLocaleDateString('en-US', { weekday: 'long' }),
    month: date.toLocaleDateString('en-US', { month: 'short' }).toUpperCase(),
    day: d,
    year: y,
  };
};

const isUpcoming = (iso) => {
  const [y, m, d] = iso.split('-').map(Number);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(y, m - 1, d) >= today;
};

const UpcomingEvents = () => {
  const upcoming = events.filter((e) => isUpcoming(e.date));

  return (
    <div className='bg-white py-16 px-4 md:px-[192px]'>

      {/* Page Header */}
      <div className='text-center mb-14'>
        <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>Come Cheer Us On</p>
        <div className='flex items-center justify-center gap-4 mb-4'>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
        </div>
        <h1 className='font-bold md:text-[48px] text-[32px] leading-tight text-gray-900' style={{ fontFamily: "'Playfair Display', serif" }}>
          Upcoming <em style={{ color: '#E40F94' }}>Events</em>
        </h1>
        <p className='mt-4 md:text-[18px] text-[16px] text-gray-500 max-w-2xl mx-auto'>
          Here's where you can catch Chilanka dancers performing this season.
        </p>
        <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
      </div>

      {/* Event List */}
      <div className='max-w-3xl mx-auto flex flex-col gap-6'>
        {upcoming.length === 0 && (
          <div className='text-center text-gray-500 text-[17px] bg-gray-50 rounded-2xl p-10'>
            New performances will be announced soon — check back shortly! ✨
          </div>
        )}

        {upcoming.map((event) => {
          const d = formatDate(event.date);
          return (
            <div
              key={event.date + event.title}
              className={`flex items-stretch rounded-2xl overflow-hidden shadow-lg border ${event.highlight ? 'border-[#E40F94] border-2' : 'border-gray-100'}`}
            >
              {/* Date block */}
              <div className='bg-[#E40F94] text-white flex flex-col items-center justify-center px-5 md:px-8 py-5 min-w-[96px] md:min-w-[120px] text-center'>
                <p className='text-[13px] font-bold tracking-[3px]'>{d.month}</p>
                <p className='text-[40px] md:text-[48px] font-bold leading-none my-1' style={{ fontFamily: "'Playfair Display', serif" }}>{d.day}</p>
                <p className='text-[12px] opacity-90'>{d.year}</p>
              </div>

              {/* Details */}
              <div className='flex-1 bg-white px-5 md:px-8 py-5'>
                <p className='text-[12px] uppercase tracking-[3px] text-gray-400 mb-1'>{d.weekday}</p>
                <h2 className='text-[20px] md:text-[24px] font-bold text-gray-900 leading-snug mb-3' style={{ fontFamily: "'Playfair Display', serif" }}>
                  {event.emoji} {event.title}
                </h2>
                <div className='flex flex-wrap gap-2'>
                  {event.performers.map((p) => (
                    <span key={p} className='text-[12px] font-semibold text-[#E40F94] bg-pink-50 border border-pink-200 rounded-full px-3 py-1'>
                      {p}
                    </span>
                  ))}
                </div>

                {event.highlight && (
                  <div className='mt-4 pt-4 border-t border-gray-100'>
                    <p className='text-gray-600 text-[15px] mb-3'>
                      Adult dancers — want to be on the court with us? NatyaFusion is welcoming new members for this show.
                    </p>
                    <Link to='/natyaFusionPage' className='inline-block bg-[#E40F94] text-white text-[14px] font-semibold px-5 py-2 rounded-full hover:bg-[#c00c7b] transition-colors duration-300'>
                      Join NatyaFusion →
                    </Link>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Past highlight */}
      <div className='text-center mt-16'>
        <p className='text-gray-500 text-[15px] mb-3'>Missed our summer performances?</p>
        <Link to='/fifaFanFestPage' className='text-[#E40F94] font-semibold hover:underline'>
          ⚽ See CHILANKA at the FIFA World Cup 2026™ Fan Festival →
        </Link>
      </div>

    </div>
  );
};

export default UpcomingEvents;
